import React from 'react'
import cn from 'classnames'

import FavoriteActivityHeader from './FavoriteActivityHeader'
import FavoriteActivityContent from './FavoriteActivityContent'
import FavoriteActivityFooter from './FavoriteActivityFooter'
import FavoriteActivityDescription from './FavoriteActivityDescription'

import './styles.scss'

const baseClass = 'favorite-activity'

const FavoriteActivity = ({
  favoriteActivity,
  quote,
  customClass,
  actionType,
  removeFromFavorites,
  addToFavorites,
  isCompletedActivityBlock,
}) => {
  const { proQuote, proQuoteAuthor, description } = favoriteActivity
  return (
    <div
      className={cn(baseClass, {
        [`${baseClass}__${customClass}`]: customClass,
      })}
    >
      <FavoriteActivityHeader
        favoriteActivity={favoriteActivity}
        actionType={actionType}
        removeFromFavorites={removeFromFavorites}
        addToFavorites={addToFavorites}
        isCompletedActivityBlock={isCompletedActivityBlock}
      />
      <FavoriteActivityContent quoteText={proQuote} />
      <FavoriteActivityFooter quoteAuthor={proQuoteAuthor}>
        <FavoriteActivityDescription description={description} />
      </FavoriteActivityFooter>
    </div>
  )
}

FavoriteActivity.displayName = 'FavoriteActivity'

export default FavoriteActivity
